import { odooSyncRoutes } from './odoo-sync';

export const integrationsRoutes = [
  {
    path: 'integrations',
    children: [...odooSyncRoutes],
  },
];
